var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("navbar"),
      _vm._m(0),
      _c(
        "div",
        { staticClass: "content search-content" },
        [
          _c("search-com", {
            attrs: { type: "customer" },
            on: {
              outputSearchData: _vm.receiveSearchData,
              searchBasic: function ($event) {
                return _vm.getStatistics($event)
              },
            },
          }),
        ],
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.baseData.loading,
              expression: "baseData.loading",
            },
          ],
          staticClass: "content",
        },
        [
          _c("h3", { staticClass: "card-title" }, [_vm._v("基础数据")]),
          _c(
            "div",
            { staticClass: "base-data-list" },
            [
              _vm._l(_vm.baseData.list, function (item, index) {
                return [
                  _c("basic-data", {
                    attrs: { basicDataItem: item, basicDataItemIndex: index },
                  }),
                ]
              }),
            ],
            2
          ),
        ]
      ),
      _c(
        "div",
        { staticClass: "content sale-chart distribution-proportion-chart" },
        [
          _c(
            "div",
            { staticClass: "sale-chart-left frequency" },
            [
              _c("h3", { staticClass: "card-title card-title-company" }, [
                _c("label", [_vm._v("客户购买频次分布")]),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("search-com-company", {
                      staticClass: "search-company",
                      attrs: {
                        type: _vm.frequency.type,
                        dateArr: _vm.frequency.dateArr,
                      },
                      on: { outputSearchData: _vm.receiveSearchData },
                    }),
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("frequency")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("echarts-frequency", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.frequency.loading,
                    expression: "frequency.loading",
                  },
                ],
                attrs: {
                  config: _vm.frequency.config,
                  dataList: _vm.frequency.dataList,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "sale-chart-right source" },
            [
              _c("h3", { staticClass: "card-title" }, [
                _c("label", [_vm._v("各平台客户来源占比")]),
                _c(
                  "div",
                  { staticClass: "staff-button-list" },
                  [
                    _c("el-button", {
                      staticClass: "download-table",
                      attrs: { size: "small", icon: "el-icon-download" },
                      on: {
                        click: function ($event) {
                          return _vm.onDownload("orderAmountPlatform")
                        },
                      },
                    }),
                  ],
                  1
                ),
              ]),
              _c("search-com-company", {
                staticClass: "search-company",
                attrs: {
                  type: _vm.orderAmountPlatform.type,
                  dateArr: _vm.orderAmountPlatform.dateArr,
                },
                on: { outputSearchData: _vm.receiveSearchData },
              }),
              _c("echarts-pie", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.orderAmountPlatform.loading,
                    expression: "orderAmountPlatform.loading",
                  },
                ],
                attrs: {
                  config: _vm.orderAmountPlatform.config,
                  dataList: _vm.orderAmountPlatform.dataList,
                },
              }),
            ],
            1
          ),
        ]
      ),
      _c("div", { staticClass: "content table-content" }, [
        _c("div", { staticClass: "table-content-item" }, [
          _c("h3", { staticClass: "card-title card-title-company" }, [
            _vm._v("新老客户人数比 "),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("search-com-company", {
                  staticClass: "search-company",
                  attrs: {
                    type: _vm.contrastPeople.type,
                    dateArr: _vm.contrastPeople.dateArr,
                  },
                  on: { outputSearchData: _vm.receiveSearchData },
                }),
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownload("contrastPeople")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { attrs: { id: "people" } },
            [
              _c("comparison", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.contrastPeople.loading,
                    expression: "contrastPeople.loading",
                  },
                ],
                attrs: {
                  documentId: "people",
                  config: _vm.contrastPeople.config,
                  dataList: _vm.contrastPeople.dataList,
                },
              }),
            ],
            1
          ),
        ]),
        _c("div", { staticClass: "table-content-item" }, [
          _c("h3", { staticClass: "card-title card-title-company" }, [
            _c("label", [_vm._v("新老客户购买金额对比")]),
            _c(
              "div",
              { staticClass: "staff-button-list" },
              [
                _c("search-com-company", {
                  staticClass: "search-company",
                  attrs: {
                    type: _vm.contrastMoney.type,
                    dateArr: _vm.contrastMoney.dateArr,
                  },
                  on: { outputSearchData: _vm.receiveSearchData },
                }),
                _c("el-button", {
                  staticClass: "download-table",
                  attrs: { size: "small", icon: "el-icon-download" },
                  on: {
                    click: function ($event) {
                      return _vm.onDownload("contrastMoney")
                    },
                  },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            { attrs: { id: "money" } },
            [
              _c("comparison", {
                directives: [
                  {
                    name: "loading",
                    rawName: "v-loading",
                    value: _vm.contrastMoney.loading,
                    expression: "contrastMoney.loading",
                  },
                ],
                attrs: {
                  documentId: "money",
                  config: _vm.contrastMoney.config,
                  dataList: _vm.contrastMoney.dataList,
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "content page-title" }, [
      _c("h2", [_vm._v("客户数据看板")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }